var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Banner animate__animated animate__fadeOutDown"},[_c('img',{attrs:{"src":require("../assets/img/imgStaly1/banner.jpg"),"alt":""}})])
}]

export { render, staticRenderFns }